function initProductSwipers() {
  const productSliders = document.querySelectorAll('.ed-product-slider');

  productSliders.forEach((product) => {
    const swiperContainer = product.querySelector('.products-swiper');

    if (swiperContainer && !swiperContainer.classList.contains('swiper-initialized')) {
      new Swiper(swiperContainer, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 8,
        navigation: {
          nextEl: ".next",
          prevEl: ".prev",
        },
        breakpoints: {
          750: {
            slidesPerView: 2,
          },
          990: {
            slidesPerView: 4,
          },
        },
      });

      swiperContainer.classList.add('swiper-initialized');
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const observer = new MutationObserver(() => {
    initProductSwipers();
  });

  const target = document.querySelector('product-recommendations');

  if (target) {
    observer.observe(target, { childList: true, subtree: true });
  }

  // Fallback for initial load if content already present
  initProductSwipers();
});
